import sample from 'lodash/sample'

import { DEFAULT_GEOXP_SPOTS } from '../constants/geoxp.constants'

interface GeoXpSpot {
  label: string
  latitude: number
  longitude: number
  radius: number
  deadband: number
}

export const getRandomSpot = (): GeoXpSpot | undefined => sample(DEFAULT_GEOXP_SPOTS)

interface GeoXpConfig {
  geo?: {
    positions?: Array<{
      id?: string
    }>
  }
  audio?: {
    sounds?: Array<{
      id?: string
      url?: string
    }>
  }
  experience?: {
    patterns?: Array<{
      id?: string
      spots?: Array<{
        id?: string
        audio?: string
        position?: string
        code?: string
      }>
    }>
  }
}

export const validateConfig = (config: GeoXpConfig): boolean => {
  // geo config
  if (!config.geo) {
    return false
  }

  if (!config.geo.positions && !Array.isArray(config.geo.positions)) {
    return false
  }

  config.geo?.positions?.forEach((pos) => {
    // if (!pos.id || !pos.lon || !pos.lat) {
    if (!pos.id) {
      return false
    }
  })

  // audio config
  if (!config.audio) {
    return false
  }

  if (!config.audio.sounds && !Array.isArray(config.audio.sounds)) {
    return false
  }

  config.audio?.sounds?.forEach((sound) => {
    if (!sound.id || !sound.url) {
      return false
    }
  })

  // experience config
  if (!config.experience) {
    return false
  }

  if (!config.experience.patterns && !Array.isArray(config.experience.patterns)) {
    return false
  }

  config.experience?.patterns?.forEach((pattern) => {
    if (!pattern.id || !pattern.spots || !Array.isArray(pattern.spots)) {
      return false
    }

    pattern.spots.forEach((spot) => {
      if (!spot.id || !spot.audio || (!spot.position && !spot.code)) {
        return null
      }
    })
  })

  // everything is ok
  return true
}
